import { useMemo } from 'react'
import { groupCartDeliveries } from '../helpers/checkout'
import { useCart } from './useCart'
import { useDeliveryLocation } from './useDeliveryLocation'
import { useExpressAvailability } from './useExpressAvailability'

export function useCartShipments() {
  const { lines } = useCart()
  const { location } = useDeliveryLocation()
  const needsCheck = lines.some((line) => typeof line.expressEligible !== 'boolean')
  const { express, checking } = useExpressAvailability(lines, location, needsCheck)
  const shipments = useMemo(
    () => groupCartDeliveries(lines, express, checking),
    [checking, express, lines],
  )

  return { shipments, checking }
}
